import {Component, OnInit} from '@angular/core';
import {OverlayConfig, OverlayRef} from 'exc-controls';
import {ExcSigninService} from 'exc-signin';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {DataImportEditMailModalComponent} from '../../data-import-edit-mail-modal/data-import-edit-mail-modal.component';
import {DefaultSettingsService} from '../../default-settings-service.service';

@Component({
  selector: 'app-modal-edit-dealer',
  templateUrl: './modal-edit-dealer.component.html',
  styles: []
})
export class ModalEditDealerComponent extends ExcTranslation implements OnInit {
  isInsert = false;
  dealer: {
    DealerName: string,
    DealerEmail: string,
    DealerCity: string,
    DealerCountry: string,
    DealerPhone: string,
    DealerStreet: string,
    DealerZip: string,
    DealerLevel1: string,
    DealerLevel2: string,
    DealerLevel3: string,
    ClientID: number,
    DealerKB: string,
    DealerHFB: string,
    AuditsPerYear: number,
    DealerRating: string,
    DealerCategory: string,
    DealerDocumentTreat: string,
    DealerWV: string,
    DealerUPT: string,
    DealerComment: string
  } = {
    DealerName: '',
    DealerEmail: '',
    DealerCity: '',
    DealerCountry: '',
    DealerPhone:  '',
    DealerStreet: '',
    DealerZip: '',
    DealerLevel1: '',
    DealerLevel2: '',
    DealerLevel3: '',
    ClientID: null,
    DealerKB: '',
    DealerHFB: '',
    AuditsPerYear: null,
    DealerRating: '',
    DealerCategory: '',
    DealerDocumentTreat: null,
    DealerWV: '',
    DealerUPT: '',
    DealerComment: 'test'
  };
  clients: [];
  docOptions = [
    {value: null, text: '-', selected: false},
    {value: 1, text: this.getGlobal('Enumeration.DocumentTreat_1'), selected: false},
    {value: 2, text: this.getGlobal('Enumeration.DocumentTreat_2'), selected: false},
    {value: 3, text: this.getGlobal('Enumeration.DocumentTreat_3'), selected: false},
    {value: 4, text: this.getGlobal('Enumeration.DocumentTreat_4'), selected: false},
    {value: 5, text: this.getGlobal('Enumeration.DocumentTreat_5'), selected: false},
    {value: 6, text: this.getGlobal('Enumeration.DocumentTreat_6'), selected: false}
  ];
  addMore = false;
  constructor(public overlayConfig: OverlayConfig, public overlayRef: OverlayRef, private excSec: ExcSigninService , private excDss: DefaultSettingsService) {
    super();
    const _self = this;
  }

  ngOnInit() {
    const _self = this;
    _self.clients = _self.overlayConfig.data.clients;
    if (_self.overlayConfig.data.data) {
      // _self.dealer = _self.overlayConfig.data.data;
      _self.dealer =  Object.assign({}, _self.overlayConfig.data.data);
    }
    if (_self.dealer.DealerName === '') {
      _self.isInsert = true;
    }
    if (_self.overlayConfig.data['IsFirstCall'] === true) {
      _self.addMore = false;
    } else {
      _self.addMore = _self.overlayConfig.data['AddMore'];
    }
  }

  addDealer () {
    const _self = this;
    _self.overlayRef.close({proceed: true, dealer: _self.dealer, addMore: _self.addMore});
  }
  /////////// temp
  showEditMail(e) {
    const _self = this;
    e.stopPropagation();
    ExcCoreModule.showModal(DataImportEditMailModalComponent, null, 'l', {Recipients: _self.dealer.DealerEmail, AllowNull: true, Title: this.overlayConfig.data.DealerName}, false, null).subscribe(ret => {
      if (ret && ret.proceed === true) {
        _self.dealer.DealerEmail = ret.Recipients;
      }
    });
  }
  setDocTreat(e) {
    const _self = this;
    _self.dealer.DealerDocumentTreat = e;
  }
  ratingChangeDetect(rating) {
    const _self = this;
    _self.dealer.DealerRating = rating;
  }
  catChangeDetect(cat) {
    const _self = this;
    _self.dealer.DealerCategory = cat;
  }
  dealerKBChangeDetect(dealerKB) {
    const _self = this;
    _self.dealer.DealerKB = dealerKB;
  }
  dealerHFBChangeDetect(dealerHFB) {
    const _self = this;
    _self.dealer.DealerHFB = dealerHFB;
  }
  isProvider() {
    const _self = this;
    return _self.excSec.isFeatured('PRV_DLR_CU');
  }
}
